import { render, staticRenderFns } from "./CustomerServiceProviders.vue?vue&type=template&id=fb0c2dd6&scoped=true&"
import script from "./CustomerServiceProviders.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceProviders.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceProviders.vue?vue&type=style&index=0&id=fb0c2dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0c2dd6",
  null
  
)

export default component.exports